import { ListMaintenanceDto } from "../_base/ListMaintenanceDto";

export class TenantResourceListMaintenanceDto extends ListMaintenanceDto {

   public tenantResourceId: number;
   public tenantResourceKey: string;
   public resource: string;

}
